export function isHapisumuDomain(domain) {
  if (/localhost.*/.test(domain)) return true
  return /.*\.?hapisumu.jp/.test(domain)
}

function getUrlWithDomain(url) {
  const pathOnly = url.startsWith('/');
  let dummyBase = pathOnly ? 'http://hapisumu.jp/' : undefined // パスのみの時にはURLはインスタンス化できないので仮のドメインを設定する
  try {
    return new URL(url, dummyBase)
  } catch (e) {
    // 不正なURL
    return null
  }
}

export function isReformLp(url) {
  if (!url) return false
  if (url.length === 0) return false

  const uri = getUrlWithDomain(url)
  if (uri === null) return false

  if (uri.hostname.length !== 0 && !isHapisumuDomain(uri.hostname)) {
    return false
  }

  return uri.pathname.startsWith("/lp/reform_")
}

export function isRebuildLp(url) {
  if (!url) return false
  if (url.length === 0) return false

  const uri = getUrlWithDomain(url)
  if (uri === null) return false

  if (uri.hostname.length !== 0 && !isHapisumuDomain(uri.hostname)) {
    return false
  }
  return uri.pathname.startsWith("/lp/rebuild_")
}

export function isLoanLp(url) {
  if (!url) return false
  if (url.length === 0) return false

  const uri = getUrlWithDomain(url)
  if (uri === null) return false

  if (uri.hostname.length !== 0 && !isHapisumuDomain(uri.hostname)) {
    return false
  }
  return uri.pathname.startsWith("/loan")
}

// 今いるURLから記事名を取得 /reform-123/ -> reform123, /rebuild/article-123/ -> rebuild/article-123
export function getPostSlug() {
  if (window.location.pathname === '/') return 'home'

  const slug = window.location.pathname.split('/').filter(function (path) {
    return path !== ''
  }).join('/')

  if (window.location.hostname.startsWith('rebuild')) return `rebuild/${slug}`

  return slug
}
